class RegFunc {

  static __funcs = {};

  static Register(name, func){
    RegFunc.__funcs[name] = func;
  }

  static Clear(name){
    delete RegFunc.__funcs[name];
  }

  static Exec(name, ...args){
    let func = RegFunc.__funcs[name];
    return func?.(...args) ?? null;
  }

  static async ExecAsync(name, ...args){
    let func = RegFunc.__funcs[name];
    return await func?.(...args) ?? null;
  }

}

export default RegFunc;